export const darkModeLogo = new URL(
    `./${import.meta.env.VITE_LOGO_DARK ?? 'logo-light'}.png`,
    import.meta.url
).href
export const lightModeLogo = new URL(
    `./${import.meta.env.VITE_LOGO_LIGHT ?? 'logo-dark'}.png`,
    import.meta.url
).href
